import { render } from "./ViewDataPSBtidakDiterima.vue?vue&type=template&id=31569902"
import script from "./ViewDataPSBtidakDiterima.vue?vue&type=script&lang=js"
export * from "./ViewDataPSBtidakDiterima.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__